// @flow

import styled from 'styled-components';
import { COLORS, SPACING } from 'clark-styles';

const { GREY_3 } = COLORS;
const { S_4 } = SPACING;

const Background = styled.div`
  background-color: ${GREY_3};
  padding-top: ${S_4};
  min-height: 100vh;
`;

export default Background;



// WEBPACK FOOTER //
// ./src/screens/sign-in/styles.js